<template>
  <div :style="themeVars">
    <v-container>
      <v-row dense class="mt-9" v-if="loading" alig="center" justify="center">
        <v-progress-circular
          indeterminate
          color="secondary-500"
        ></v-progress-circular>
      </v-row>
      <div v-else>
        <v-row dense class="mt-9">
          <v-row dense>
            <v-col>
              <v-card
                elevation="1"
                style="
                  border-radius: 10px;
                  position: relative;
                  overflow: visible;
                "
              >
                <v-card-text>
                  <v-row dense style="padding: 2vh">
                    <v-col cols="12" md="10">
                      <div class="d-flex align-start justify-start flex-column">
                        <span class="header">Gerenciar turmas</span>
                        <span class="regular mt-4"
                          >Atualize, acompanhe e visualize suas turmas em um
                          formato mais prático.</span
                        >
                      </div>
                    </v-col>
                    <v-col cols="12" md="2" class="image-col"> </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-row>

        <v-row dense class="mt-8">
          <v-col cols="12" md="4">
            <v-card class="summary-card summary-card--primary" elevation="1">
              <v-card-text>
                <div class="summary-label">Total de turmas</div>
                <div class="summary-value">{{ classes.length }}</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="summary-card summary-card--secondary" elevation="1">
              <v-card-text>
                <div class="summary-label">Turmas ativas</div>
                <div class="summary-value">{{ activeClasses }}</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="summary-card summary-card--neutral" elevation="1">
              <v-card-text>
                <div class="summary-label">Em formação</div>
                <div class="summary-value">{{ pendingClasses }}</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense class="mt-6" v-if="classes.length > 0">
          <v-col
            v-for="(item, index) in classes"
            :key="index"
            cols="12"
            sm="6"
            xl="4"
            class="d-flex"
          >
            <v-card class="class-card d-flex flex-column" elevation="2">
              <div class="class-card__cover">
                <div class="class-card__cover-overlay"></div>

                <div class="class-card__cover-content">
                  <div>
                    <div class="class-card__eyebrow">Turma</div>
                    <div class="class-card__title">{{ item.cod }}</div>
                  </div>

                  <v-chip
                    small
                    dark
                    :color="statusColor(item.status)"
                    class="font-weight-medium"
                  >
                    {{ statuses[item.status] || "Sem status" }}
                  </v-chip>
                </div>
              </div>

              <v-card-text class="flex-grow-1">
                <div class="info-grid">
                  <div class="info-box">
                    <span class="info-box__label">Nível</span>
                    <strong class="info-box__value">
                      {{ englishLevels[item.level] || "Não informado" }}
                    </strong>
                  </div>

                  <div class="info-box">
                    <span class="info-box__label">Dias</span>
                    <strong class="info-box__value">
                      {{ item.weekDays ? item.weekDays.length : 0 }}
                    </strong>
                  </div>
                </div>

                <div class="section-title mt-5">Dias da semana</div>
                <div class="chips-wrap mt-2">
                  <v-chip
                    v-for="(day, ind) in item.weekDays"
                    :key="`${item.id}-day-${ind}`"
                    small
                    outlined
                    color="secondary-500"
                    class="mr-2 mb-2"
                  >
                    {{ weekDaysItems[day]?.text || day }}
                  </v-chip>
                </div>

                <div class="section-title mt-4">Horários</div>
                <div class="chips-wrap mt-2">
                  <v-chip
                    v-for="(hour, ind) in item.hours"
                    :key="`${item.id}-hour-${ind}`"
                    small
                    color="secondary-100"
                    text-color="secondary-700"
                    class="mr-2 mb-2"
                  >
                    {{ hour }}
                  </v-chip>
                </div>

                <div class="section-title mt-4">Alunos</div>
                <div
                  v-if="Array.isArray(item.content) && item.content.length"
                  class="chips-wrap mt-2"
                >
                  <v-chip
                    v-for="(student, studentIndex) in item.content"
                    :key="`${item.id}-student-${student.id || studentIndex}`"
                    small
                    class="mr-2 mb-2 class-card__student-chip"
                  >
                    <v-avatar
                      left
                      size="24"
                      :color="student.avatar ? '' : 'secondary-500'"
                    >
                      <v-img
                        v-if="student.avatar"
                        :src="student.avatar"
                        cover
                      />
                      <span
                        v-else
                        class="white--text class-card__student-avatar-text"
                      >
                        {{ studentInitials(student.name) }}
                      </span>
                    </v-avatar>
                    <span class="class-card__student-name">
                      {{ student.name }}
                    </span>
                  </v-chip>
                </div>
                <div v-else class="class-card__empty-text mt-2">
                  Nenhum aluno vinculado no momento.
                </div>
              </v-card-text>

              <v-card-actions class="px-4 pb-4 pt-0">
                <v-btn
                  block
                  dark
                  rounded
                  color="secondary-500"
                  @click="classDetails(item.id)"
                >
                  <v-icon small left>mdi-eye-outline</v-icon>
                  Visualizar turma
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense class="mt-8" v-else-if="!loading">
          <v-col cols="12">
            <v-card class="empty-card" elevation="1">
              <v-card-text
                class="d-flex flex-column align-center justify-center py-10"
              >
                <v-icon color="secondary-500" size="42">
                  mdi-book-open-page-variant-outline
                </v-icon>
                <div class="empty-card__title mt-4">
                  Nenhuma turma encontrada
                </div>
                <div class="empty-card__text mt-2">
                  Assim que houver turmas cadastradas, elas aparecerão aqui em
                  cards responsivos.
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import partnerApi from "@/shared/pitchPartnerApi";
import Colors from "@/styles/app.module.scss";

function hexToRgba(hex, alpha) {
  const normalized = hex.replace("#", "");
  const chunkSize = normalized.length === 3 ? 1 : 2;
  const segments = normalized.match(new RegExp(`.{${chunkSize}}`, "g")) || [];
  const [r, g, b] = segments.map((segment) => {
    const value = chunkSize === 1 ? `${segment}${segment}` : segment;
    return Number.parseInt(value, 16);
  });

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export default {
  name: "PartnerClasses",
  created() {
    partnerApi
      .getStudyGroups()
      .then((res) => {
        this.classes = res.data;
      })
      .catch(() => {
        this.$root.$emit("display-alert", {
          text: "Nao foi possivel carregar a lista de turmas.",
          type: 1,
        });
      })
      .finally(() => {
        this.loading = false;
      });
  },
  data() {
    return {
      loading: true,
      classes: [],

      typeOptions: [
        { text: "Individual", value: 1 },
        { text: "Dupla", value: 2 },
        { text: "Trio", value: 3 },
        { text: "Quarteto", value: 4 },
      ],
      weekDaysItems: [
        {
          text: "Domingo",
          value: 0,
        },
        {
          text: "Segunda-feira",
          value: 1,
        },
        {
          text: "Terça-feira",
          value: 2,
        },
        {
          text: "Quarta-feira",
          value: 3,
        },
        {
          text: "Quinta-feira",
          value: 4,
        },
        {
          text: "Sexta-feira",
          value: 5,
        },
        {
          text: "Sábado",
          value: 6,
        },
      ],
      frequencies: [
        { text: "Uma vez na semana", value: 1 },
        { text: "Duas vezes na semana", value: 2 },
      ],
      times: [
        {
          text: "1 Hora",
          value: 1,
        },
        {
          text: "1 Hora e 30 minutos",
          value: 2,
        },
      ],
      englishLevels: {
        0: "BEGGINER1",
        1: "BEGGINER2",
        2: "ESSENTIAL1",
        3: "ESSENTIAL2",
        4: "PREINTERMEDIATE1",
        5: "PREINTERMEDIATE2",
        6: "INTERMEDIATE1",
        7: "INTERMEDIATE2",
        8: "UPPER1",
        9: "UPPER2",
        10: "ADVANCED1",
        11: "ADVANCED2",
      },
      statuses: {
        0: "Em formação",
        1: "Ativa",
        2: "Encerrada",
      },
    };
  },
  computed: {
    activeClasses() {
      return this.classes.filter((item) => +item.status === 1).length;
    },
    pendingClasses() {
      return this.classes.filter((item) => +item.status === 0).length;
    },
    themeVars() {
      const primary = Colors["secondary-500"];
      const primaryStrong = Colors["secondary-600"];

      return {
        "--partner-primary": primary,
        "--partner-primary-light": Colors["secondary-400"],
        "--partner-primary-strong": primaryStrong,
        "--partner-primary-deep": Colors["secondary-700"],
        "--partner-primary-soft": hexToRgba(primary, 0.06),
        "--partner-primary-soft-alt": hexToRgba(primary, 0.12),
        "--partner-primary-cover": hexToRgba(primary, 0.9),
        "--partner-primary-cover-strong": hexToRgba(primaryStrong, 0.82),
        "--partner-border": hexToRgba(primary, 0.16),
        "--partner-text-strong": Colors["secondary-700"],
        "--partner-text-body": "#111827",
        "--partner-text-muted": "#6b7280",
      };
    },
  },
  methods: {
    classDetails(classId) {
      this.$router.push({
        path: `/connect/professor/turmas/${classId}`,
        params: classId,
      });
    },
    statusColor(status) {
      const colors = {
        0: "amber darken-2",
        1: "green darken-1",
        2: "blue-grey darken-1",
      };

      return colors[status] || "grey";
    },
    studentInitials(name) {
      const parts = String(name || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2);

      return (
        parts
          .map((part) => part[0])
          .join("")
          .toUpperCase() || "AL"
      );
    },
  },
};
</script>

<style lang="css" scoped>
.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}

.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}

.normal {
  text-transform: none;
}

.summary-card {
  border-radius: 22px;
  color: #fff;
  overflow: hidden;
}

.summary-card--primary {
  background: linear-gradient(
    135deg,
    var(--partner-primary) 0%,
    var(--partner-primary-strong) 100%
  );
}

.summary-card--secondary {
  background: linear-gradient(
    135deg,
    var(--partner-primary-strong) 0%,
    var(--partner-primary-deep) 100%
  );
}

.summary-card--neutral {
  background: linear-gradient(
    135deg,
    var(--partner-primary-light) 0%,
    var(--partner-primary) 100%
  );
}

.summary-label {
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  opacity: 0.86;
  text-transform: uppercase;
}

.summary-value {
  margin-top: 10px;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
}

.class-card {
  width: 100%;
  border-radius: 24px;
  overflow: hidden;
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    var(--partner-primary-soft) 100%
  );
  border: 1px solid var(--partner-border);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.class-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 28px 50px -38px rgba(15, 23, 42, 0.42);
}

.class-card__cover {
  position: relative;
  min-height: 132px;
  background-image: linear-gradient(
      135deg,
      var(--partner-primary-cover),
      var(--partner-primary-cover-strong)
    ),
    url("@/assets/images/unsplash_professor.webp");
  background-size: cover;
  background-position: center;
}

.class-card__cover-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.05),
    rgba(15, 23, 42, 0.2)
  );
}

.class-card__cover-content {
  position: relative;
  z-index: 1;
  min-height: 132px;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.class-card__eyebrow {
  color: rgba(255, 255, 255, 0.86);
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.class-card__title {
  margin-top: 8px;
  color: #fff;
  font-size: 1.45rem;
  font-weight: 700;
  line-height: 1.15;
}

.info-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.info-box {
  padding: 14px 16px;
  border-radius: 18px;
  background: var(--partner-primary-soft-alt);
}

.info-box__label {
  display: block;
  color: var(--partner-text-muted);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.info-box__value {
  display: block;
  margin-top: 8px;
  color: var(--partner-text-body);
  font-size: 0.95rem;
  line-height: 1.45;
}

.section-title {
  color: var(--partner-text-strong);
  font-size: 0.9rem;
  font-weight: 700;
}

.chips-wrap {
  display: flex;
  flex-wrap: wrap;
}

.class-card__student-chip {
  max-width: 100%;
  background: var(--partner-primary-soft-alt) !important;
  color: var(--partner-text-body) !important;
  font-weight: 600;
}

.class-card__student-avatar-text {
  font-size: 0.65rem;
  font-weight: 700;
}

.class-card__student-name {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.class-card__empty-text {
  color: var(--partner-text-muted);
  font-size: 0.9rem;
}

.empty-card {
  border-radius: 24px;
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    var(--partner-primary-soft) 100%
  );
}

.empty-card__title {
  color: var(--partner-text-body);
  font-size: 1.1rem;
  font-weight: 700;
}

.empty-card__text {
  max-width: 420px;
  color: var(--partner-text-muted);
  text-align: center;
  line-height: 1.6;
}

@media (max-width: 600px) {
  .class-card__cover-content {
    flex-direction: column;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }
}
</style>
